/* ================================
   Cart Drawer - Complementary Products Recommendations
   Prestige 9
   ================================ */

let isInjecting = false;
let currentInjectionId = null;

async function injectCartComplementaryRecommendations() {
  const container = document.getElementById('CartDrawerRecommendationsTarget');
  if (!container) return;
  
  if (isInjecting) return;
  
  const injectionId = Date.now();
  
  if (currentInjectionId && (injectionId - currentInjectionId) < 1000) return;
  
  isInjecting = true;
  currentInjectionId = injectionId;

  try {
    const cart = await fetch('/cart.js').then(res => res.json());
    const productIdsInCart = cart.items.map(item => item.product_id);
    
    if (productIdsInCart.length === 0) {
      container.innerHTML = '';
      return;
    }

    const sectionId = 'cart-drawer-recommendations';
    const limitsPerProduct = getComplementaryLimits(productIdsInCart.length);
    const productsToQuery = productIdsInCart.slice(0, 3);

    const allHtmlResults = await Promise.all(
      productsToQuery.map((productId, index) =>
        fetch(`/recommendations/products?section_id=${sectionId}&product_id=${productId}&limit=${limitsPerProduct[index]}&intent=complementary`)
          .then(r => r.text())
          .catch(() => null)
      )
    );

    if (currentInjectionId !== injectionId) return;

    const seenIds = new Set(productIdsInCart.map(id => String(id)));
    const allProductCards = [];

    allHtmlResults.forEach((html, productIndex) => {
      if (!html) return;
      
      const temp = document.createElement('div');
      temp.innerHTML = html;

      const items = temp.querySelectorAll('.cart-drawer-reco__item[data-product-id]');
      let countForThisProduct = 0;
      const maxForThisProduct = limitsPerProduct[productIndex];

      items.forEach(item => {
        if (countForThisProduct >= maxForThisProduct) return;
        
        const productId = item.getAttribute('data-product-id');
        if (!productId || seenIds.has(productId)) return;
        
        seenIds.add(productId);
        
        const clonedItem = item.cloneNode(true);
        
        // Supprimer les modales existantes
        clonedItem.querySelectorAll('quick-buy-modal').forEach(modal => modal.remove());
        
        // Récupérer les infos du produit pour le bouton
        const productLink = clonedItem.querySelector('a[href*="/products/"]');
        const productHandle = productLink ? productLink.href.split('/products/')[1].split('?')[0] : null;
        
        // Remplacer les boutons par un bouton qui utilise la modale partagée
        clonedItem.querySelectorAll('button[aria-controls^="modal-"]').forEach(btn => {
          if (productHandle) {
            const newBtn = document.createElement('button');
            newBtn.className = 'horizontal-product-card__button link';
            newBtn.textContent = btn.textContent;
            newBtn.setAttribute('data-product-handle', productHandle);
            newBtn.setAttribute('data-open-quick-buy', 'true');
            btn.replaceWith(newBtn);
          } else {
            btn.remove();
          }
        });
        
        allProductCards.push(clonedItem);
        countForThisProduct++;
      });
    });

    if (allProductCards.length === 0) {
      container.innerHTML = '';
      return;
    }

    const carouselId = 'cart-drawer-reco-carousel-' + injectionId;
    const sharedModalId = 'cart-drawer-reco-shared-modal';

    const cardsHtml = allProductCards.map(card => {
      const content = card.firstElementChild || card;
      content.style.cssText = 'flex: 0 0 85%; min-width: 0; scroll-snap-align: start;';
      return content.outerHTML;
    }).join('');
    
    // Supprimer l'ancienne modale partagée si elle existe
    document.getElementById(sharedModalId)?.remove();
    
    // Détection de la langue
    const locale = document.documentElement.lang || window.Shopify?.locale || 'fr';
    const recommendationsTitle = locale.startsWith('en') ? 'You may also like' : 'Vous aimerez aussi';
    const srLabel = locale.startsWith('en') ? 'Go to item' : 'Aller à l\'élément';
    
    container.innerHTML = `
      <div class="complementary-products">
        <div class="complementary-products__header complementary-products__header--align-start">
          <p class="h6">${recommendationsTitle}</p>
          ${allProductCards.length > 1 ? `
            <carousel-navigation aria-controls="${carouselId}" class="page-dots page-dots--narrow">
              ${allProductCards.map((_, i) => `
                <button class="relative" aria-current="${i === 0 ? 'true' : 'false'}">
                  <span class="sr-only">${srLabel} ${i + 1}</span>
                </button>
              `).join('')}
            </carousel-navigation>
          ` : ''}
        </div>
        <scroll-carousel id="${carouselId}" class="complementary-products__product-list complementary-products__product-list--carousel scroll-area bleed snap-x" style="display: flex; gap: 12px; overflow-x: auto; scroll-snap-type: x mandatory;">
          ${cardsHtml}
        </scroll-carousel>
      </div>
      <quick-buy-modal id="${sharedModalId}" class="quick-buy-modal modal modal--lg color-scheme color-scheme--dialog"></quick-buy-modal>
    `;
    
    // Ajouter les event listeners pour les boutons quick-buy
    container.querySelectorAll('[data-open-quick-buy]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const handle = btn.getAttribute('data-product-handle');
        const modal = document.getElementById(sharedModalId);
        if (modal && handle) {
          modal.setAttribute('handle', handle);
          modal.show();
        }
      });
    });
    
  } finally {
    isInjecting = false;
  }
}

function getComplementaryLimits(cartItemCount) {
  switch (cartItemCount) {
    case 1:
      return [2];
    case 2:
      return [1, 1];
    default:
      return [1, 1, 1];
  }
}

/* ================================
   Initialisation
   ================================ */

let cartDrawerRecoInitialized = false;

function initCartDrawerRecommendations() {
  if (cartDrawerRecoInitialized) return;
  
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  cartDrawerRecoInitialized = true;

  cartDrawer.addEventListener('dialog:after-show', () => {
    injectCartComplementaryRecommendations();
  });
  
  cartDrawer.addEventListener('dialog:after-hide', () => {
    document.getElementById('cart-drawer-reco-shared-modal')?.remove();
    currentInjectionId = null;
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initCartDrawerRecommendations();
});

document.addEventListener('cart:change', () => {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer?.hasAttribute('open')) {
    setTimeout(injectCartComplementaryRecommendations, 500);
  }
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('cart-drawer')) {
      cartDrawerRecoInitialized = false;
      initCartDrawerRecommendations();
    }
  });
}

(function () {
  if (window.matchMedia('(hover: hover)').matches) return;

  function initScrollbar(card) {
    const media = card.querySelector('.product-card__media');
    const secondary = card.querySelector('.product-card__image--secondary');
    if (!media || !secondary) return;

    const track = document.createElement('div');
    track.className = 'product-card__scrollbar';
    const thumb = document.createElement('div');
    thumb.className = 'product-card__scrollbar-thumb';
    track.appendChild(thumb);
    media.insertAdjacentElement('afterend', track);

    function updateThumb() {
      const ratio = media.scrollLeft / (media.scrollWidth - media.clientWidth);
      const thumbWidth = (media.clientWidth / media.scrollWidth) * 100;
      thumb.style.width = thumbWidth + '%';
      thumb.style.transform = `translateX(${ratio * (media.clientWidth - thumb.offsetWidth)}px)`;
    }

    updateThumb();
    media.addEventListener('scroll', updateThumb, { passive: true });
  }

  document.querySelectorAll('.product-card').forEach(initScrollbar);

  // Pour les cards chargées dynamiquement (ex: pagination infinie)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        node.querySelectorAll('.product-card').forEach(initScrollbar);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();